import { render, staticRenderFns } from "./CardWithSpace.vue?vue&type=template&id=5d34c12e&scoped=true&"
import script from "./CardWithSpace.vue?vue&type=script&lang=js&"
export * from "./CardWithSpace.vue?vue&type=script&lang=js&"
import style0 from "./CardWithSpace.vue?vue&type=style&index=0&id=5d34c12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34c12e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
